import React, { Component} from 'react';
import sty from 'styled-components';
import { Link } from 'react-router-dom';

import m from '../services/media';

export default class Live extends Component {
  render(){
    const live = this.props.live
    
    if(live){
        var description = live.snippet.description.replace("Curta nossa página: https://www.facebook.com/atibaiatv", "");
        var title = live.snippet.title
        var date = new Date(live.snippet.publishedAt);
        if(date === new Date()){
        date = `Hoje ${date.getHours()}h${date.getMinutes()}`
        } else {
        date = `${date.getDay()<10?'0'+date.getDay():date.getDate()}/${date.getMonth()+1<10?'0'+(date.getMonth()+1):(date.getMonth()+1)} ${date.getHours()}h${date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()}`
        }
            
    
        return <VideoContainer>
            <Video>
            <FrameContainer>
                <Frame src={"https://www.youtube.com/embed/"+live.id.videoId+'?autoplay=1'} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen >
                </Frame>
            </FrameContainer>
            </Video>
            <PostDescription>
              <PostHead>
                <LiveBadge>
                  <LiveText>
                    AO VIVO
                  </LiveText>
                </LiveBadge>
                <PostTitle>
                  {title}
                </PostTitle>
              </PostHead>
            <PostText>
                {description.slice(0,100)}
            </PostText>
            <PostDate>
                {date}
            </PostDate>
            </PostDescription>
        </VideoContainer>
    }
    return null
  }
}

const VideoContainer = sty.div`
    margin: 0 auto;
    flex-direction: column;
    align-self: center;
    justify-content: center;
`
const Video = sty.div`
display: block;
max-width: 50rem
flex-direction: column;
overflow-y: scroll;
${m.sm`
`};
${m.md`
padding: 0 5px;
`};
${m.lg`
padding: 0 5px;
`};
`
const FrameContainer = sty.div`
flex: 0 0 100%;
align-self: center;
max-width: 60rem
height: 0;
position: relative;
padding-top: 56.25%;
overflow: hidden;
box-shadow: 0 .1rem .3rem #888a;
${m.sm`
`};
${m.md`
border-radius: 1rem
`};
${m.lg`
border-radius: 1rem;
`};
`
const Frame = sty.iframe`
position: absolute;
width: 100%;
height: 100%;
left: 0;
top: 0;
border: none;
`
const PostHead = sty.div`

`
const PostDescription = sty.div`
  padding: .3rem .7rem .7rem .7rem;
  flex-direction: column;
`
const PostTitle = sty.h2`
  font-family: 'Ubuntu', sans-serif;
  font-size: 1rem;
  line-height: 1.3rem;
  font-weight: 500;
  overflow: hidden;
  margin: .5rem .5rem;
  padding: .5rem 0 0 0;
  position: relative;
  flex: 1 0;
  &:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 15%;
    height: 1.5em;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 70%);
  };
`
const PostText = sty.h2`
  font-family: 'Ubuntu', sans-serif;
  font-size: .8rem;
  line-height: 1rem;
  font-weight: 400;
  max-height: 3rem;
  margin: 0 .5rem;
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1 0;
  -webkit-line-clamp: ellipsis
  &:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 15%;
    height: 1rem;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 70%);
  };
`
const PostDate = sty.p`
  margin: .5rem .5rem .5rem .5rem;
`

const LiveBadge = sty.div`
  background-color: #ff0066;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
  border-radius: 5px;
  align-self: center
`
const LiveText = sty.p`
  color: white;
  font-weight: bold;
  margin: 0;
  font-size: 12px
`